/* Good Candy — PDP polish (PD 7/15/2026)
 * 1) Reviews block (theme "apps" section): relabel "FAQs" -> "Reviews", hide the
 *    "@EATGOODCANDY" subheading, shrink the oversized type, contain + center the widget,
 *    cap flavor PDPs at 3 cards, and route "See more reviews" to the Sampler PDP.
 * 2) "Nothing to Hide" graphic (left of the FAQ section, .tcc-faq-image): click to open
 *    the Nutrition Facts / Ingredients image full-size so it's easy to read. This is the
 *    ONLY image wired for the lightbox — the product gallery is intentionally left alone.
 *    (7/17: on-image "Tap to enlarge" badge removed per client request — the image itself
 *    stays clickable.)
 * (7/21: reviews block compacted per client request - smaller heading/score/name type
 *  and tighter spacing so the section takes less vertical space on all PDPs.)
 * Scoped to product pages; the homepage is left untouched.
 */
(function () {
  var SAMPLER_PATH = '/products/6-pack-sampler';

  // Pop-out image shown for the "Nothing to Hide" graphic (Nutrition Facts / Ingredients)
  // on every product PDP.
  var NUTRITION_POPUP_IMG = 'https://cdn.shopify.com/s/files/1/0685/6264/9238/files/Ingredients-Pop-Up.png?v=1784151346';

  function isProductPage() {
    return !!(document.body && document.body.classList.contains('template-product'));
  }
  function isSamplerPage() {
    return location.pathname.replace(/\/+$/, '') === SAMPLER_PATH;
  }

  function injectStyle() {
    if (document.getElementById('gc-reviews-style')) return;
    var css =
      /* --- reviews block --- */
      'body.template-product .section--apps{padding-top:36px !important;}' +
      'body.template-product .section--apps .apps__subheader{display:none !important;}' +
      'body.template-product .section--apps .yotpo-widget-instance{max-width:1200px !important;margin-left:auto !important;margin-right:auto !important;}' +
      'body.template-product .section--apps .yotpo-review-title,body.template-product .section--apps .yotpo-review-title strong{font-size:18px !important;line-height:1.25 !important;}' +
      'body.template-product .section--apps .yotpo-reviewer-name,body.template-product .section--apps .yotpo-reviewer-name-text{font-size:20px !important;line-height:1.1 !important;}' +
      'body.template-product .section--apps .yotpo-date-format{font-size:13px !important;}' +
      'body.template-product .section--apps .yotpo-read-more-text{font-size:15px !important;}' +
      '@media screen and (min-width:992px){' +
        'body.template-product .section--apps .apps__header{font-size:38px !important;line-height:1 !important;}' +
        'body.template-product .section--apps .yotpo-header-container{padding-bottom:12px !important;}' +
        'body.template-product .section--apps .yotpo-bottom-line-score{font-size:38px !important;}' +
      '}' +
      '@media screen and (max-width:989px){' +
        'body.template-product .section--apps .apps__header{font-size:30px !important;line-height:1 !important;}' +
      '}' +
      /* --- nutrition / ingredients zoom (FAQ section image only) --- */
      'body.template-product .tcc-faq-image{position:relative;}' +
      'body.template-product .tcc-faq-image img{cursor:zoom-in;}' +
      /* --- lightbox --- */
      '#gc-lightbox{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.85);padding:24px;box-sizing:border-box;}' +
      '#gc-lightbox.gc-lb-open{display:flex;}' +
      '#gc-lightbox .gc-lb-img{max-width:94vw;max-height:90vh;object-fit:contain;border-radius:10px;background:#fff;box-shadow:0 12px 48px rgba(0,0,0,.45);}' +
      '#gc-lightbox .gc-lb-close{position:absolute;top:16px;right:22px;width:50px;height:50px;font-size:30px;line-height:44px;text-align:center;color:#111;background:#EDFF8D;border:3px solid #000;border-radius:50%;cursor:pointer;font-family:inherit;padding:0;}';
    if (!isSamplerPage()) {
      css += 'body.template-product .section--apps .yotpo-reviews-list-wrapper .yotpo-reviews-item:nth-of-type(n+4){display:none !important;}';
    }
    var s = document.createElement('style');
    s.id = 'gc-reviews-style';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function relabel() {
    document.querySelectorAll('.apps__header').forEach(function (h) {
      if (/^\s*FAQs\s*$/i.test(h.textContent)) h.textContent = 'Reviews';
    });
  }
  function addAnchor() {
    var apps = document.querySelector('[data-section-type="section_apps"]');
    if (apps && !document.getElementById('reviews')) {
      var a = document.createElement('span');
      a.id = 'reviews';
      a.setAttribute('aria-hidden', 'true');
      a.style.cssText = 'display:block;height:0;scroll-margin-top:120px;';
      apps.insertBefore(a, apps.firstChild);
    }
  }

  /* ---------- image lightbox ---------- */
  var lbImg;
  function ensureLightbox() {
    if (document.getElementById('gc-lightbox')) return;
    var lb = document.createElement('div');
    lb.id = 'gc-lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML = '<button type="button" class="gc-lb-close" aria-label="Close">×</button><img class="gc-lb-img" alt="">';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.gc-lb-img');
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.gc-lb-close')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }
  function openLightbox(src, alt) {
    ensureLightbox();
    lbImg.src = src;
    lbImg.alt = alt || '';
    var lb = document.getElementById('gc-lightbox');
    lb.classList.add('gc-lb-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    var lb = document.getElementById('gc-lightbox');
    if (!lb) return;
    lb.classList.remove('gc-lb-open');
    lb.setAttribute('aria-hidden', 'true');
    if (lbImg) lbImg.src = '';
    document.body.style.overflow = '';
  }
  function hiRes(src) {
    try {
      var u = new URL(src, location.origin);
      u.searchParams.set('width', '1600');
      u.searchParams.delete('height');
      return u.toString();
    } catch (e) {
      return src;
    }
  }
  function initNutritionZoom() {
    var host = document.querySelector('.tcc-faq-image');
    if (!host) return;
    var img = host.querySelector('img');
    if (!img || img.dataset.gcZoom) return;
    img.dataset.gcZoom = '1';
    img.setAttribute('title', 'Click to enlarge — read the Nutrition Facts & Ingredients');
    function openIt(e) {
      if (e) e.preventDefault();
      openLightbox(NUTRITION_POPUP_IMG || hiRes(img.currentSrc || img.src), img.alt || 'Nutrition Facts and Ingredients');
    }
    img.addEventListener('click', openIt);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  injectStyle();
  ready(function () {
    if (!isProductPage()) return;
    relabel();
    addAnchor();
    initNutritionZoom();
    if (location.hash === '#reviews') {
      setTimeout(function () {
        var t = document.getElementById('reviews');
        if (t) t.scrollIntoView();
      }, 700);
    }
    if (!isSamplerPage()) {
      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest &&
          e.target.closest('[data-apps-see-more-reviews], .apps-see-more-reviews');
        if (btn) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = SAMPLER_PATH + '#reviews';
        }
      }, true);
    }
  });
})();
